type ReviewerOffsetUnit = "Hour" | "Day";
const ReviewerOffsetUnit = {
    HOUR: "Hour" as ReviewerOffsetUnit,
    DAY: "Day" as ReviewerOffsetUnit,
};

type PeriodUnit = "Month" | "TwoMonths" | "Quarter" | "Half" | "Year";

interface LegacyControlCoveredPeriod {
    Offset: number;
    Unit: PeriodUnit;
}

interface NotificationOffset {
    DaysBefore: number;
    Hour: number;
    Minute: number;
}
export type { LegacyControlCoveredPeriod, NotificationOffset, PeriodUnit };
export { ReviewerOffsetUnit };
